import {Box} from '@mui/material';
import React from 'react';

export const NoRouteMatch = () => {
  return <Box className='innerPage'>No Route Match</Box>;
};
